import type { WebsiteContent } from './types'

export const services: WebsiteContent['services'] = {
  title: 'What we do',
  subtitle: 'Services & Solutions',
  description:
    'Our AI Native enablement proves value and delivers in weeks not months. Our stakeholders get a clear return on their investments, and your teams moves forward quickly with confidence.',
  groups: [
    {
      title: 'Strategy',
      description:
        'We partner with customers to assess their current capabilities, identify high-impact AI opportunities, and define a clear vision and actionable roadmap for AI transformation.',
    },
    {
      title: 'Build',
      description:
        'We design, develop, and deploy custom AI solutions tailored to solve specific business challenges and deliver measurable outcomes.',
    },
    {
      title: 'Activation',
      description:
        'We help organizations maximize their investments in AI platforms by building agents, workflows, and solutions that empower teams to operate more efficiently.',
    },
  ],
}
